export const metricsComparisonChart = (data = []) => {
  const metrics = data.map(d => d.metric || d.label);

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' }
    },
    legend: {
      data: ['Pre-Deploy', 'Post-Deploy'],
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '3%',
      top: '10%',
      bottom: '12%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: metrics,
      axisLabel: { fontSize: 10, rotate: data.length > 6 ? 30 : 0 }
    },
    yAxis: {
      type: 'value',
      axisLabel: { fontSize: 10 }
    },
    series: [
      {
        name: 'Pre-Deploy',
        type: 'bar',
        data: data.map(d => d.preValue ?? 0),
        itemStyle: {
          color: '#1890ff',
          borderRadius: [4, 4, 0, 0]
        },
        barGap: '10%'
      },
      {
        name: 'Post-Deploy',
        type: 'bar',
        data: data.map(d => ({
          value: d.postValue ?? 0,
          itemStyle: {
            color: Math.abs(d.deviation || 0) > 50 ? '#f5222d' : '#52c41a',
            borderRadius: [4, 4, 0, 0]
          }
        }))
      }
    ]
  };
};
